module.exports = __webpack_public_path__ + "static/midolo-ca0c601549a1713e9cc30d5dbf918f76.jpg";